import { types } from 'mobx-state-tree'

const VenueEndModel = types.model('VenueEndModel', {
  id: types.identifier,
  name: types.string,
})

export default VenueEndModel
